import app_img from '@/public/article/App.webp';
import estimate_img from '@/public/article/Estimate_1.webp';
import gps_img from '@/public/article/GPS-Tracking.webp';
import article1 from '@/public/article/picture.webp';
import route_img from '@/public/article/Route Optimization.webp';
import schedule_img from '@/public/article/Schedule_1.webp';
import main_bg from '@/public/industries/plumbing/plumbing_industry_bg.webp';
import image4 from '@/public/industries/plumbing/transaction.webp';
import review1 from '@/public/reviews/CapterraSvg.svg';
import review2 from '@/public/reviews/GetAppSvg.svg';
import review3 from '@/public/reviews/SoftwareAdvice.svg';
import { ArticleType } from '@/types/articles';
import { IRoutePath } from '@/types/router';

const faq = [
  {
    title: 'What are the benefits of using software for plumbing businesses?',
    text: 'Plumbing software streamlines operations, from scheduling and dispatching to invoicing and customer management. It enhances efficiency, reduces paperwork, and improves customer service, making it invaluable for both small and large plumbing businesses.',
  },
  {
    title: 'How can software help grow a small plumbing business?',
    text: 'Software for small plumbing businesses automates key processes, allowing for more jobs to be completed efficiently. This leads to increased customer satisfaction, repeat business, and referrals, which are crucial for growth.',
  },
  {
    title: `Does Orcatec's plumbers business software include a mobile app?`,
    text: `Yes, Orcatec's plumbers software comes with a user-friendly mobile app, enabling technicians to manage jobs, view schedules, and process payments on-the-go, ensuring seamless field operations`,
  },
];

const testimonals = [
  {
    text: `Since integrating Orcatec into our daily operations, we've seen a remarkable shift in our workflow efficiency. The GPS tracking feature has especially been a game-changer for us, ensuring our plumbers are always on the fastest route, saving us both time and money.`,
    name: 'James P.,',
    position: 'BlueWave Plumbing',
  },
  {
    text: `Orcatec's dispatching system is incredibly intuitive and easy to use. Our customer satisfaction rates have soared due to the improved response times. This software really does what it promises and more.`,
    name: 'Maria G.,',
    position: 'AquaFlow Services',
  },
  {
    text: 'The estimate feature in Orcatec has streamlined how we do software for plumbing contractors. Being able to track when a client views their estimate and getting electronic acceptances has increased our job wins significantly.',
    name: 'Ethan K.,',
    position: 'PipeMasters Inc.',
  },
  {
    text: `Since integrating Orcatec into our daily operations, we've seen a remarkable shift in our workflow efficiency. The GPS tracking feature has especially been a game-changer for us, ensuring our plumbers are always on the fastest route, saving us both time and money.`,
    name: 'James P.,',
    position: 'BlueWave Plumbing',
  },
  {
    text: `Orcatec's dispatching system is incredibly intuitive and easy to use. Our customer satisfaction rates have soared due to the improved response times. This software really does what it promises and more.`,
    name: 'Maria G.,',
    position: 'AquaFlow Services',
  },
  {
    text: 'The estimate feature in Orcatec has streamlined how we do software for plumbing contractors. Being able to track when a client views their estimate and getting electronic acceptances has increased our job wins significantly.',
    name: 'Ethan K.,',
    position: 'PipeMasters Inc.',
  },
];

const industries = {
  title: 'Our industries',
  description: `Explore our range of specialized software solutions tailored for different industries. Whether you're in heating, service, contracting, or running a small company, our software is meticulously designed to address the distinctive needs of your projects.`,
  items: [
    { title: 'HVAC', path: IRoutePath.INDUSTRIES_HVAC },
    { title: 'Plumbing', path: IRoutePath.INDUSTRIES_PLUMBING },
    { title: 'Appliance Repair', path: IRoutePath.INDUSTRIES_APPLIANCE },
    { title: 'Electrician', path: IRoutePath.INDUSTRIES_ELECTRICIAN },
    { title: 'Garage Door', path: IRoutePath.INDUSTRIES_GARAGE_DOOR },
    {
      title: 'Construction',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Property Maintenance',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Junk Removal',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Home Cleaning',
      path: IRoutePath.INDUSTRIES_HOME_CLEANING,
    },
    {
      title: 'Handyman',
      path: IRoutePath.INDUSTRIES_HANDYMAN,
    },
    {
      title: 'Landscaping and Lawn',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Construction',
      path: IRoutePath.INDUSTRIES_CONSTRUCTION,
    },

    {
      title: 'Home Renovation',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Automotive',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Pest Control',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Custom Home Building',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Custom Home Building',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Window Cleaning',
      path: IRoutePath.INDUSTRIES,
    },

    {
      title: 'Carpet Cleaning',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Pool and Spa Service',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Locksmith',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Fireplace and Chimney',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Roofing',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Water Treatment',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Alarm and Security',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Irrigation',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Painting Contractors',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Fire Safety',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Computer Service',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Moving',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Snow Removal',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Snow Removal',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Air Duct Cleaning',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Remodeling',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Janitorial Services',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Excavation',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Demolition Contractor',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Tree Care',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Restoration',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Flooring',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Tiling',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Drywall',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Pressure Washing',
      path: IRoutePath.INDUSTRIES,
    },
  ],
};

const articles = {
  title: `Software Features Made for Plumbing Businesses`,
  items: [
    {
      type: ArticleType.VERICAL,
      image: {
        path: schedule_img,
        alt: 'Job Scheduling',
      },
      href: '#',
      tag: 'Job Scheduling',
      title: 'Optimize Field Operations',
      text: `Orcatec's dispatching system provides an easy-to-use drag-and-drop interface, color-coded appointments, and real-time data synchronization to ensure efficient job management software for plumbers.`,
      list: [
        { text: 'Assign the right technician to the right job' },
        { text: 'Manage work time or vacations' },
        { text: 'Rearrange schedules to meet customer demands effectively' },
      ],
    },

    {
      type: ArticleType.VERICAL,
      image: {
        path: estimate_img,
        alt: 'Estimate',
      },
      href: '#',
      tag: 'Estimate',
      title: 'Simple Estimation',
      text: `With Orcatec, creating and tracking estimates is simplified. Plumbers can offer Good, Better, Best models, attach files to estimates, and get electronic acceptance from clients. The plumbing management software also notifies when a client views an estimate, streamlining the follow-up process and enhancing the chances of winning the job.`,
      list: [
        {
          text: 'Send your estimates via email, text, copying and pasting a link, or dowloading them as PDFs',
        },
        { text: 'Good, Better, Best models' },
        { text: 'Individual line item options' },
        { text: 'Create payment schedules' },
      ],
    },

    {
      type: ArticleType.HORIZONTAL,
      image: {
        path: route_img,
        alt: 'Route Optimization',
      },
      href: '#',
      tag: 'Route Optimization',
      title: 'Save Time With AI',
      text: `The AI route optimizer suggests the best technician, date, and time for appointments based on customizable settings. This feature is crucial for plumbing businesses looking to maximize efficiency, reduce fuel costs, and provide timely service to their customers.`,
      list: [
        { text: 'Provision of real-time updates on job status and changes' },
        {
          text: 'Mobile access to job information and schedules',
        },
        { text: 'Immediate communication and collaboration tools' },
      ],
    },

    {
      type: ArticleType.VERICAL,
      image: {
        path: image4,
        alt: 'Credit Card Processing',
      },
      href: '#',
      tag: 'Credit Card Processing',
      title: 'Seamless Transactions, Secure Finances',
      text: `Orcatec's integrated credit card feature enables secure and quick transactions with very low processing fees. It supports mobile credit card terminals, electronic invoicing, and instant payment notifications, facilitating a seamless financial experience for both the plumber and the customer.`,
      list: [
        { text: 'Very low processing fees' },
        { text: 'Mobile credit card terminals' },
        { text: 'Ability to send an invoice for payment' },
        { text: 'Get instant notification if the invoice had been paid' },
      ],
    },
    {
      type: ArticleType.VERICAL,
      image: {
        path: gps_img,
        alt: 'GPS Tracking ',
      },
      href: '#',
      tag: 'GPS Tracking',
      title: 'Minimize The Windshield Time',
      text: `Utilizing GPS tracking, Orcatec helps plumbing businesses monitor their field technicians' locations, optimize routes from their exact geo-locations, and minimize non-billable travel time. This feature not only enhances productivity but also contributes to cost savings and
      improved customer service by providing accurate ETAs`,

      list: [
        {
          text: 'Track and record the GPS location of your employees via mobile device when the employee is clocked in',
        },
        { text: 'Route optimization from exact geo location' },
        { text: 'See the history of trails and travel speed' },
      ],
    },
  ],
};

const intro = {
  imageSrc: main_bg,
  tag: 'Plumbing Business Software',
  title: {
    first_part: 'Pipeline to Success:',
    second_part: 'Empowering Your Flow of Work!',
  },
  description:
    'Experience the next level of efficiency with our software for plumbing business, the ultimate tool designed to streamline your plumbing operations. Our software easily handles everything from scheduling and dispatching to job estimation and customer relationship management. Say goodbye to paperwork and hello to increased productivity and profitability.',
  info: [
    { title: '5x', description: 'Faster Invoicing' },
    { title: '40%', description: 'Reduction in Fuel Costs' },
  ],
};

const fullArticle1 = {
  image: {
    path: article1.src,
    alt: 'What Is Software for Plumbers?',
  },
  title: 'What Is Software for Plumbers?',
  description: `Software for plumbers streamlines business management for the plumbing industry, offering key features like scheduling, job estimating, invoicing, CRM, and equipment orders. These tools come together in a unified centralized system, improving operations, workflow, and customer service, fostering business growth and profitability:`,
  item: [
    {
      title: 'Seamless Scheduling & Dispatch:',
      description:
        'Find the right technician for the job and get them there fast with optimized appointment-setting and dispatching tools.',
    },
    {
      title: 'Accurate Job Estimates:',
      description:
        'Convert estimates into invoices automatically and track payments efficiently for improved cash flow.',
    },
    {
      title: 'Effortless Invoicing & Payments:  ',
      description:
        'Convert estimates into invoices automatically and track payments efficiently for improved cash flow.',
    },
    {
      title: 'Personalized Customer Service: ',
      description:
        'Maintain detailed customer records in our CRM to deliver a personalized experience and drive retention.',
    },
  ],
};

const fullArticle2 = {
  image: {
    path: app_img,
    alt: 'Why Plumbing Pros Choose Orcatec?',
  },
  title: 'Why Plumbing Pros Choose Orcatec?',
  description: `Tired of juggling paperwork and leaky software? Orcatec empowers plumbing contractors like you with powerful tools built specifically for your needs. Here's how we unlock your success:`,
  item: [
    {
      title: 'Free Starter Package:',
      description:
        'Get essential features (scheduling, estimates, invoices) without upfront costs. Test the waters and see the difference!',
    },
    {
      title: 'Pay-As-You-Go Flexibility:',
      description:
        'Only pay for the features you use. No more bloated software packages draining your budget.',
    },
    {
      title: 'Customize Your Workflow:',
      description: ` Adapt the software to fit your unique processes. Build custom forms, workflows, and reports that streamline your day.`,
    },
    {
      title: 'Mobile Magic:',
      description: `Manage your business on the go, from any device: PC, tablet, or smartphone.`,
    },

    {
      title: 'Platform Freedom:',
      description: `Use Orcatec on your preferred devices, whether iOS or Android. We play nice with everyone.`,
    },
  ],
};

const reviews = {
  title: 'Our Reviews',
  items: [
    { path: review1.src, width: review1.width, alt: 'Capterra' },
    { path: review2.src, width: review2.width, alt: 'GetApp' },
    { path: review3.src, width: review3.width, alt: 'Software Advice' },
  ],
};

const blog = {
  title: 'Our Blog',
  description: `Dive into our informative blog articles, where we explore various aspects of business management and industry insights, offering valuable knowledge to help you stay ahead in the dynamic world of plumbing and contracting. Discover tips, trends, and strategic advice tailored to enhance your business operations and growth.`,
};

const bookDemo = {
  title: 'Book a Free Demo',
  description: `Book a free demo to unlock the full potential of our software for plumbing contractors! Orcatec team is here to guide you. Fill out the form below to receive expert consultation. Don’t miss this opportunity to transform your plumbing business with Orcatec's cutting-edge solutions, specially designed for plumbing contractors!`,
};

export {
  reviews,
  fullArticle2,
  fullArticle1,
  intro,
  articles,
  industries,
  testimonals,
  faq,
  blog,
  bookDemo,
};
